<template>
    <div class="wrapper">
        <v-row>
        <v-col cols="1" md="1" lg="2" xl="2">
        </v-col>
        <v-col cols="10" md="12" lg="8" xl="8">
            <div class="wrapper-background" style="border:0px solid blue;">
                <div class="onkopus-content" style="border:0px solid red;">
                    <v-row style="height:40px;"></v-row>
                    <v-row>
                        <v-col cols="3" md="3" lg="2" xl="2">
                                <router-link :to="`${this.$store.getters.getRouterBaseURL}/`" id="onkopus-logo">
                                    <img width="120" src="../../assets/onkopus_logo_v0.1.4.2_640.png"
                                        class="start-logo"
                                    />
                                </router-link>
                        </v-col>
                        <v-col justify="bottom" align="left" style="padding-top:20px;border:0px solid red;">
                            <span style="font-size: 4rem;">
                                Onkopus
                            </span>
                        </v-col>
                    </v-row>
                    <div style="height:20px;">
                    </div>
                    <div style="margin-bottom: 20px;font-size:18px;margin-top:20px;">
                        A platform for the biological and clinical interpretation of cancer variants
                        <br>
                    </div>
                    <div style="border: var(--default-blue) solid 0px; border-radius: 5px;">
                        <SearchBar @clear-table="this.$store.dispatch('clearAGG')"></SearchBar>
                    </div>

                </div>

                <div style="height:5px;">
                </div>

                <div class="onkopus-content">
                    <div><b>Sample requests</b></div>
                    <table class="sample-request-tb">
                        <tr><td>
                            <span>
                            Single nucleotide variants
                            </span>
                        </td>
                        <td>
                                <span>
                                <router-link :to="`${this.$store.getters.getRouterBaseURL}/upload/show-variant-interpretation-results-q?q=chr7:140753336A>T&genome_version=hg38&tumor_type=/`">
                                    chr7:140753336A>T
                                </router-link>
                                </span>
                            </td>

                        <td>
                            <span>
                            <router-link :to="`${this.$store.getters.getRouterBaseURL}/upload/show-variant-interpretation-results-q?q=KRAS:G12C&genome_version=hg38&tumor_type=/`">
                                KRAS:p.G12C
                            </router-link>
                            </span>
                        </td>
                        <td>
                            <span>
                            <router-link :to="`${this.$store.getters.getRouterBaseURL}/upload/show-variant-interpretation-results-q?q=NM_004985.5:c.35G>A&genome_version=hg38&tumor_type=/`">
                                NM_004985.5:c.35G>A
                            </router-link>
                            </span>
                        </td>
                    </tr>
                    <!--<tr><td>
                        <span>
                        Insertions/deletions
                        </span>
                        </td>
                        <td>
                            <span>
                            <router-link :to="`${this.$store.getters.getRouterBaseURL}/upload/show-variant-interpretation-results-q?q=chr7:g.140753336A>T&genome_version=hg38&tumor_type=/`">
                                chr7:g.140753336A>T
                            </router-link>
                            </span>
                        </td>
                        <td>
                            <span>
                            <router-link :to="`${this.$store.getters.getRouterBaseURL}/upload/show-variant-interpretation-results-q?q=KRAS:G12C&genome_version=hg38&tumor_type=/`">
                                KRAS:p.G12C
                            </router-link>
                            </span>
                        </td>
                        <td></td>
                    </tr>-->
                    <tr><td>
                        <div>
                            <span>Gene fusions</span>
                        </div></td>
                        <td>
                            <span>
                            <router-link :to="`${this.$store.getters.getRouterBaseURL}/upload/show-variant-interpretation-results-q?q=CHR7:47368770-CHRX:67643257&genome_version=hg38&tumor_type=/`">
                                chr7:47368770-chrX:67643257
                            </router-link>
                            </span>
                        </td></tr>

                        <!--<tr><td>
                            <span>
                            Insertions/deletions
                            </span>
                            </td>
                            <td>
                                <span>
                                <router-link :to="`${this.$store.getters.getRouterBaseURL}/upload/show-variant-interpretation-results-q?q=chr7:g.140753336A>T&genome_version=hg38&tumor_type=/`">
                                    chr7:g.140753336A>T
                                </router-link>
                                </span>
                            </td>
                            <td>
                                <span>
                                <router-link :to="`${this.$store.getters.getRouterBaseURL}/upload/show-variant-interpretation-results-q?q=KRAS:G12C&genome_version=hg38&tumor_type=/`">
                                    KRAS:p.G12C
                                </router-link>
                                </span>
                            </td>
                            <td></td>
                        </tr>-->
                            <tr><td><div><span>Genes</span></div></td>
                                <td>
                                    <span>
                                    <router-link :to="`${this.$store.getters.getRouterBaseURL}/upload/show-variant-interpretation-results-q?q=TP53&genome_version=hg38&tumor_type=/`">
                                        TP53
                                    </router-link>
                                    </span>
                               </td>
                               <td>
                                    <span>
                                    <router-link :to="`${this.$store.getters.getRouterBaseURL}/upload/show-variant-interpretation-results-q?q=RET&genome_version=hg38&tumor_type=/`">
                                        RET
                                    </router-link>
                                    </span>
                               </td>
                               <td></td>
                            </tr></table>
                </div>

                <div class="onkopus-content" style="border:1px solid #f5f5f5;padding:10px;">
                    <div><b>News</b></div>
                    <div style="height:10px;"></div>
                    <ul><li>
                        Discover our latest publication of Onkopus <a href="https://academic.oup.com/nar/article/53/W1/W431/8133628">here</a>.
                        <router-link :to="`${this.$store.getters.getRouterBaseURL}/contact`">More info</router-link></li>
                    </ul>
                </div>

                <div style="height:5px;">
                </div>

                <div style="margin:40px;font-size:16px;">
                    <v-row justify="center" align="center">
                        <v-col cols="0" md="0" lg="2" xl="2"></v-col>
                        <v-col cols="12" md="6" lg="4" xl="4" justify="center" align="center">
                            <table>
                                <tr>
                                    <td>
                                        <v-icon icon="mdi-magnify" color="#fff" size="42" style="background-color: var(--default-blue);
                                            border-radius: 15%;" />
                                    </td>
                                    <td style="padding-left:20px;">
                                        Search and analyze genes, single nucleotide variants (SNVs), insertions and deletions,
                                        copy number variations (CNVs) and gene fusions
                                    </td>
                                </tr>
                            </table>
                        </v-col>
                        <v-col cols="12" md="6" lg="4" xl="4">
                            <table><tr><td>
                                <v-icon icon="mdi-text-box-search" color="#fff" size="42" style="background-color: #388E3C;
                                        border-radius: 15%;" />
                            </td>
                            <td style="padding-left:20px;">
                                Analyze evidence-based treatment options
                            </td></tr></table>
                        </v-col>
                        <v-col cols="0" md="0" lg="2" xl="2"></v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="0" md="0" lg="2" xl="2"></v-col>
                        <v-col cols="12" md="6" lg="4" xl="4">
                            <table><tr><td>
                                <v-icon icon="mdi-molecule" color="#fff" size="42" style="background-color: #FFA726;
                                        border-radius: 15%;" />
                            </td>
                            <td style="padding-left:20px;">
                                Analyze biochemical and structural features of sequence variants and proteins
                            </td></tr></table>
                        </v-col>
                        <v-col cols="12" md="6" lg="4" xl="4">
                            <table><tr><td>
                                <v-icon icon="mdi-sitemap-outline" color="#fff" size="42" style="background-color: #26C6DA;
                                        border-radius: 15%;" />
                            </td>
                            <td style="padding-left:20px;">
                                Build your own custom annotation pipelines for your research project
                            </td></tr></table>
                        </v-col>
                        <v-col cols="0" md="0" lg="2" xl="2"></v-col>
                    </v-row>
                </div>

                    <!--<div id="onkopus-about-grid">
                        <div class="onkopus-about-item">
                            <v-icon icon="mdi-magnify" color="#fff" size="42" style="background-color: var(--default-blue);
                                    border-radius: 15%;" />
                            Search and analyze genes, single nucleotide variants (SNVs), insertions and deletions,
                            copy number variations (CNVs) and gene fusions
                        </div>
                        <div class="onkopus-about-item">
                            <v-icon icon="mdi-text-box-search" color="#fff" size="42" style="background-color: #388E3C;
                                    border-radius: 15%;" />
                            Analyze evidence-based treatment options for variants and patients
                        </div>
                        <div class="onkopus-about-item">
                            <v-icon icon="mdi-upload" color="#fff" size="42" style="background-color: #FFA726;
                                    border-radius: 15%;" />
                            Upload and annotate your own variant files (VCF, MAF, CSV, XLSX)
                        </div>
                        <div class="onkopus-about-item">
                            <v-icon icon="mdi-sitemap-outline" color="#fff" size="42" style="background-color: #26C6DA;
                                    border-radius: 15%;" />
                            Build your own custom annotation pipelines for your research project
                        </div>
                    </div>-->
                </div>
                <!--<div id="onkopus-image"></div>-->
                    <v-container>
                        <v-row align="center">
                            <v-col align="center">
                                <img src="@/assets/creative-commons-783531_960_720.png" width="100" />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col align="center">

                                <!--This website does not use cookies. -->
                                Content on this site is licensed under a
                                <a href="https://creativecommons.org/licenses/by-sa/4.0/deed.en">
                                    Creative Commons Attributions-ShareAlike-4.0 International License (CC BY-SA 4.0)
                                </a>
                                    .
                            </v-col>
                        </v-row>
                    </v-container>
                </v-col>
                <v-col cols="1" md="1" lg="2" xl="2">
                    <div class="side-background">
                    </div>
                </v-col>
            </v-row>
        </div>
</template>

<script>
import SearchBar from '@/components/query_components/SearchBar.vue';


export default {
    name: 'start',
    components: {
        SearchBar,
    },
}
</script>

<style scoped>
.wrapper {
    /*background-color: var(--dark-blue);*/
    background-color: #ffffff;
    /*color: var(--white);*/
    /*background: url("../../assets/dna_v0.2.png") no-repeat center center fixed;
    webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;*/
    color: #505050;
    width: 100%;
    height: 100%;
    background-image: url('@/assets/dna_v0.9.png');
    background-repeat: no-repeat;
    background-position: right center;
    background-size: cover;
}

.side-background {
    /*background-color: var(--dark-blue);*/
    /*background-color: #ffffff;*/
    /*color: var(--white);*/
    /*background: url("../../assets/dna_v0.2.png") no-repeat center center fixed;
    webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;*/
    color: #505050;
    width: 100%;
    height: 100%;
    /*background-image: url('@/assets/dna_v0.6.png');*/
    background-repeat: no-repeat;
    background-position: right center;
    background-size: cover;
    transform: translate(-35%, 300px);
}

.onkopus-content {
    /*margin-left:20%;*/
    margin-top: 20px;
    width: 100%;
}

#onkopus-image {
    opacity: 0.8;
    width: 800px;
    height: 720px;
    background-image: url("../../assets/onkopus_logo_10_1000x1000.png");
    background-repeat: no-repeat;
    background-size: contain;
    position: absolute;
    right: 0;
    top: 450px;
    /*transform: translate(35%, -300px);*/
    transform: translate(-35%, 300px);
    scale: 1 1;
    display: none;
}

#onkopus-about-grid {
    display: grid;
    padding-top: 42px;
    width: 100%;
    gap: 32px;
    margin: auto;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: minmax(50px, 100px), minmax(50px, 100px);
    font-family: Roboto;
}

.onkopus-about-item {
    display: flex;
    gap: 12px;
    align-content: flex-start;
}

.start-logo {
    border-radius: 50%;
    /*min-height: 500px;
    min-width: 500px;*/
    background-color:#ffffff;
}

.start-logo:hover {
    background-color:#4d4d4d;
}

.sample-request-tb tr td span {
    margin-right:10px;
}

.v-icon {
    padding: 16px !important;
}

@media (max-width: 1536px) {
    .wrapper {
        background-image: none;
    }
}

@media (min-width: 900px) {

    #onkopus-image {
        display: block;
        animation: movin 2s;
    }

    .onkopus-content {
        width: 100%;
    }

    @keyframes movin {
        0% {
            transform: translate(120%, -400px);
        }

        70% {
            transform: translate(30%, -350px);
        }

        100% {
            transform: translate(35%, -300px);
        }
    }


}
</style>
